import { render, staticRenderFns } from "./DropdownVatType.vue?vue&type=template&id=61cb3948&scoped=true&"
import script from "./DropdownVatType.vue?vue&type=script&lang=ts&"
export * from "./DropdownVatType.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownVatType.vue?vue&type=style&index=0&id=61cb3948&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cb3948",
  null
  
)

export default component.exports